module.exports = __webpack_public_path__ + "img/logo.7b102d66.png";